import { computed, ComputedRef } from "vue";
import { BaseInputAffix, NormalizedBaseInputAffix } from "@/src/design_system/form_elements/base_input/types";

interface UseDSBaseInputAffixArgs {
  prefix: ComputedRef<BaseInputAffix | undefined>;
  suffix: ComputedRef<BaseInputAffix | undefined>;
  useAffixes: ComputedRef<boolean>;
}

interface UseDSBaseInputAffix {
  normalizedPrefix: ComputedRef<NormalizedBaseInputAffix | undefined>;
  normalizedSuffix: ComputedRef<NormalizedBaseInputAffix | undefined>;
}

export const useDSBaseInputAffix = ({ prefix, suffix, useAffixes }: UseDSBaseInputAffixArgs): UseDSBaseInputAffix => {
  const normalizeAffix = (affix?: BaseInputAffix): NormalizedBaseInputAffix | undefined => {
    if (!useAffixes.value) {
      return undefined;
    }

    if (typeof affix === "string") {
      return { icon: affix };
    }

    return affix;
  };

  const normalizedPrefix = computed(() => normalizeAffix(prefix.value));
  const normalizedSuffix = computed(() => normalizeAffix(suffix.value));

  return {
    normalizedPrefix,
    normalizedSuffix,
  };
};
